// @flow
import { DocumentosActionTypes } from './constants';

// import { APICore } from '../../helpers/api/apiCore';

// const api = new APICore();

const INIT_STATE = {
    documento: {},
    documentoPreview: {},
    listaDocumentos: [],
    listaDocumentosPreview: [],
    loading: false,
    loadingForm: false,
    error: false,
    formSubmited: false,
    filters: {}
};

type DocumentosAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { documento?: {} | null, listaDocumentos?: [] | null, loading?: boolean, +value ?: boolean };

const Documentos = (state: State = INIT_STATE, action: DocumentosAction): any => {
    // console.log(action);
    switch (action.type) {
        case DocumentosActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case DocumentosActionTypes.GET_DOCUMENTO: {
                    return {
                        ...state,
                        documento: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case DocumentosActionTypes.GET_DOCUMENTO_PREVIEW: {
                    return {
                        ...state,
                        documentoPreview: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case DocumentosActionTypes.LIST_DOCUMENTOS: {
                    return {
                        ...state,
                        listaDocumentos: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case DocumentosActionTypes.LIST_DOCUMENTOS_PREVIEW: {
                    return {
                        ...state,
                        listaDocumentosPreview: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case DocumentosActionTypes.ADD_DOCUMENTO: {
                    return {
                        ...state,
                        error: false,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case DocumentosActionTypes.UPDATE_DOCUMENTO: {
                    return {
                        ...state,
                        error: false,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case DocumentosActionTypes.DELETE_DOCUMENTO: {
                    return {
                        ...state,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case DocumentosActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case DocumentosActionTypes.GET_DOCUMENTO: {
                    return {
                        ...state,
                        error: action.payload.error,
                        documento: {},
                        loading: false,
                    };
                }
                case DocumentosActionTypes.GET_DOCUMENTO_PREVIEW: {
                    return {
                        ...state,
                        error: action.payload.error,
                        documentoPreview: {},
                        loading: false,
                    };
                }
                case DocumentosActionTypes.LIST_DOCUMENTOS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        listaDocumentos: [],
                        loading: false,
                    };
                }
                case DocumentosActionTypes.LIST_DOCUMENTOS_PREVIEW: {
                    return {
                        ...state,
                        error: action.payload.error,
                        listaDocumentosPreview: [],
                        loading: false,
                    };
                }
                case DocumentosActionTypes.ADD_DOCUMENTO: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case DocumentosActionTypes.UPDATE_DOCUMENTO: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loadingForm: false,
                        formSubmited: true
                    };
                }
                case DocumentosActionTypes.DELETE_DOCUMENTO: {
                    return {
                        ...state,
                        error: action.payload.error,
                        loading: false,
                        formSubmited: true
                    };
                }
                default:
                    return { ...state };
            }

        case DocumentosActionTypes.GET_DOCUMENTO:
            return { ...state, error: false, loading: true };
        case DocumentosActionTypes.GET_DOCUMENTO_PREVIEW:
            return { ...state, error: false, loading: true };
        case DocumentosActionTypes.LIST_DOCUMENTOS:
            return { ...state, error: false, loading: true };
        case DocumentosActionTypes.LIST_DOCUMENTOS_PREVIEW:
            return { ...state, error: false, loading: true };
        case DocumentosActionTypes.ADD_DOCUMENTO:
            return { ...state, error: false, loadingForm: true };
        case DocumentosActionTypes.UPDATE_DOCUMENTO:
            return { ...state, error: false, loadingForm: true };
        case DocumentosActionTypes.DELETE_DOCUMENTO:
            return { ...state, error: false, loading: true };
        case DocumentosActionTypes.RESET:
            return {
                ...state,
                loading: false,
                loadingForm: false,
                error: false,
                documento: {},
                documentoPreview: {},
                listaDocumentos: [],
                listaDocumentosPreview: [],
                formSubmited: false,
            };
        case DocumentosActionTypes.SET_FILTER:
            return {
                ...state,
                filters: action.payload
            }
        default:
            return { ...state };
    }
};

export default Documentos;
